const AdditionalStructures = require("./additional-structures");
const OtherAreas = require("./other-areas");
const OtherAreasMMH = require("./other-areas-mmh");

module.exports = { AdditionalStructures, OtherAreas, OtherAreasMMH };
